var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#A80000",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2778 18.8359H14.5218C13.021 18.8359 11.7998 20.0571 11.7998 21.557V28.2759C11.7998 29.7766 13.021 30.997 14.5218 30.997H35.2778C36.7786 30.997 37.9998 29.7758 37.9998 28.2759V21.557C37.9998 20.0571 36.7786 18.8359 35.2778 18.8359ZM36.4173 28.2759C36.4173 28.9036 35.9056 29.4144 35.2778 29.4144H14.5218C13.894 29.4144 13.3824 28.9036 13.3824 28.2759V21.557C13.3824 20.9293 13.894 20.4185 14.5218 20.4185H35.2778C35.9056 20.4185 36.4173 20.9293 36.4173 21.557V28.2759Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6328 23.7832C18.0068 23.7832 17.4995 24.2905 17.4995 24.9165C17.4995 25.5425 18.0068 26.0498 18.6328 26.0498C19.2588 26.0498 19.7661 25.5425 19.7661 24.9165C19.7661 24.2905 19.2588 23.7832 18.6328 23.7832Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8999 23.7832C24.2739 23.7832 23.7666 24.2905 23.7666 24.9165C23.7666 25.5425 24.2739 26.0498 24.8999 26.0498C25.5259 26.0498 26.0332 25.5425 26.0332 24.9165C26.0332 24.2905 25.5259 23.7832 24.8999 23.7832Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1665 23.7832C30.5405 23.7832 30.0332 24.2905 30.0332 24.9165C30.0332 25.5425 30.5405 26.0498 31.1665 26.0498C31.7925 26.0498 32.2998 25.5425 32.2998 24.9165C32.2998 24.2905 31.7925 23.7832 31.1665 23.7832Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUIcon3);
export default __webpack_public_path__ + "static/media/u_icon3.dbd0e15eb637ab618d0a6e36c7c1bdc6.svg";
export { ForwardRef as ReactComponent };